/**
 * Standardized discharge types, reasons, and medico-legal defaults
 * for IPD Discharge Summary architecture (including LAMA and DAMA).
 */

export const DISCHARGE_TYPES = [
  { value: "Regular", label: "Regular / Routine Discharge" },
  { value: "DAMA", label: "DAMA (Discharged Against Medical Advice)" },
  { value: "LAMA", label: "LAMA (Left Against Medical Advice)" },
  { value: "Absconded", label: "Absconded (Left Without Notice)" },
  { value: "Transfer / Referral", label: "Transfer / Referral to Higher Center" },
  { value: "Deceased", label: "Deceased" },
];

export const LAMA_DAMA_REASONS = [
  "Financial constraints",
  "Personal / Family reasons",
  "Patient feeling better / wanting to go home",
  "Seeking treatment at another hospital / Higher center",
  "Seeking alternative / traditional therapy",
  "Dissatisfaction with hospital care / facilities",
  "Domestic emergency",
  "Other",
];

export const SURROGATE_RELATIONSHIPS = [
  "Self",
  "Spouse",
  "Father",
  "Mother",
  "Son",
  "Daughter",
  "Brother",
  "Sister",
  "Guardian",
  "Other",
];

export const LAMA_DAMA_DEPARTURE_CONDITIONS = [
  "Stable",
  "Guarded",
  "Critical",
  "Unstable",
];

export const DEFAULT_LAMA_DAMA_DECLARATION =
  "I / We hereby declare that I am leaving / taking the patient from the hospital entirely against the medical advice of the treating doctors. The clinical condition, need for continued inpatient treatment, and grave risks of premature departure (including disease progression, permanent disability, or death) have been fully explained to me in a language I understand. I assume full responsibility for all consequences and absolve the hospital, treating doctors, and staff of any liability arising from this departure.";

export const isLamaOrDama = (type) => {
  const norm = String(type || "").trim().toUpperCase();
  return (
    norm === "LAMA" ||
    norm === "DAMA" ||
    norm.includes("AGAINST MEDICAL ADVICE") ||
    norm.includes("LAMA") ||
    norm.includes("DAMA")
  );
};

export const defaultLamaDamaDetails = (header = {}) => ({
  discharge_type: isLamaOrDama(header.discharge_type)
    ? String(header.discharge_type).toUpperCase().includes("LAMA")
      ? "LAMA"
      : "DAMA"
    : "DAMA",
  reason: "Financial constraints",
  reason_other: "",
  counseled_by: header.consultant_incharge || "",
  risks_explained: true,
  risks_explained_notes:
    "Potential risks of premature departure, including clinical deterioration, disease progression, complications, and mortality were explained in detail.",
  surrogate_name: "",
  surrogate_relationship: "Self",
  surrogate_contact: "",
  condition_at_departure:
    header.discharge_details?.condition_at_discharge || "Guarded",
  emergency_instructions:
    "Advised to report immediately to the nearest emergency center in case of worsening symptoms or medical distress. The patient remains welcome to return to this hospital at any time.",
  can_return_anytime: true,
  declaration_text: DEFAULT_LAMA_DAMA_DECLARATION,
  declaration_acknowledged: true,
});
